import { adaptPreferencias, toWirePreferencias } from '@/shared/domain/adapters';
import type {
  PreferenciasConfig,
  PreferenciasRemotas,
  PreferenciasServidor,
} from '@/shared/domain/types';
import { apiAxios } from '../api';
import { toResult } from '../handlers';
import type { ApiResult } from '../types';
import { priv, type RequestOpts } from './common';

/**
 * Preferencias en la nube (/v1/usuarios/yo/preferencias) con concurrencia optimista: si `versionBase` no es
 * la del servidor responde 409 `version_desfasada` y `error.extra` trae la copia del servidor
 * (léela con `adaptPreferencias`).
 */
export const prefsApi = {
  /** `config: null` y `version: 0` si nunca se guardaron. */
  getPreferencias: (opts?: RequestOpts): Promise<ApiResult<PreferenciasRemotas>> =>
    toResult(
      apiAxios.get({ url: '/usuarios/yo/preferencias', config: priv(opts) }),
      adaptPreferencias,
    ),

  putPreferencias: (
    versionBase: number,
    config: PreferenciasConfig,
    opts?: RequestOpts,
  ): Promise<ApiResult<PreferenciasServidor>> =>
    toResult(
      apiAxios.put({
        url: '/usuarios/yo/preferencias',
        data: { version_base: versionBase, config: toWirePreferencias(config) },
        config: priv(opts),
      }),
      (raw) => {
        const r = adaptPreferencias(raw);
        if (!r.config || !r.actualizado) throw new Error('preferencias: respuesta incompleta');
        return { version: r.version, config: r.config, actualizado: r.actualizado };
      },
    ),
};
